var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.breadcrumbs}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }